const formatInputFloat = (val: any, numberOfDecimal = 2) => {
  const numberValue = Number(String(val).replace(/,/gi, "."));
  if (!val) return "0";
  return Number(numberValue.toFixed(numberOfDecimal)).toLocaleString("id");
};
export default formatInputFloat;
